import React, { Fragment, useEffect, useState } from 'react'
import { Listbox } from '@headlessui/react'
import classNames from 'classnames'
import { ChevronDownIcon } from 'components/icons'
import { PropertiesOrderByColumn, SortOrder } from 'gql/graphql'

type PropTypes = {
  onSortChange: (value: {column: string, order: string}[]) => void
}

const PropertiesSortSelect = ({ onSortChange }: PropTypes) => {
  const sortItems = [
    { value: null, name: 'Sort By...' },
    { value: 'price-l-h', name: 'Price Low - High' },
    { value: 'price-h-l', name: 'Price High - Low' },
    { value: 'bedrooms-l-h', name: 'Bedrooms Min - Max' },
    { value: 'bedrooms-h-l', name: 'Bedrooms Max - Min' },
    { value: 'most_popular', name: 'Most popular' },
  ]

  const [selectedSort, setSelectedSort] = useState(sortItems[0])

  useEffect(() => {
    switch (selectedSort?.value) {
      case 'price-l-h':
        onSortChange([
          { column: PropertiesOrderByColumn.StayCost, order: SortOrder.Asc },
          { column: PropertiesOrderByColumn.PriceRange, order: SortOrder.Asc },
        ])
        break
      case 'price-h-l':
        onSortChange([
          { column: PropertiesOrderByColumn.StayCost, order: SortOrder.Desc },
          { column: PropertiesOrderByColumn.PriceRange, order: SortOrder.Desc },
        ])
        break
      case 'bedrooms-l-h':
        onSortChange([
          { column: PropertiesOrderByColumn.Bedrooms, order: SortOrder.Asc },
        ])
        break
      case 'bedrooms-h-l':
        onSortChange([
          { column: PropertiesOrderByColumn.Bedrooms, order: SortOrder.Desc },
        ])
        break
      case 'most_popular':
        onSortChange([
          { column: PropertiesOrderByColumn.Popularity, order: SortOrder.Desc },
        ])
        break
    }
  }, [selectedSort])

  return (
    <Listbox
      className="md:max-w-[200px] w-full px-20 md:px-0 ml-auto text-14 leading-20 text-grey-900 relative"
      as="div"
      value={selectedSort}
      onChange={setSelectedSort}
    >
      {({ open }) => (
        <>
          <Listbox.Button
            className={classNames('flex items-center justify-between w-full px-20 border border-grey-400 py-15', {
              'rounded-t-4': open,
              'rounded-4': !open,
            })}>
            <span>{selectedSort?.name}</span>
            <span className="flex items-center justify-center w-20 h-20">
              {open
                ? ' - '
                : <ChevronDownIcon/>
              }
            </span>
          </Listbox.Button>

          <Listbox.Options
            className="absolute inset-x-20 lg:inset-x-0 z-10 py-8 bg-white border-b top-[calc(100%-1px)] border-x border-grey-400 rounded-b-4"
          >
            {sortItems.map((sortItem, index) => (
              <Listbox.Option
                key={index}
                value={sortItem}
                disabled={!sortItem.value}
                as={Fragment}
              >
                {({ active }) => {
                  const classname = classNames({
                    'hidden': sortItem.value === null,
                    'bg-primary-fresh bg-opacity-20': active,
                  })

                  return (
                    <div className={classNames('px-20 py-[6px] cursor-pointer', classname)}>
                      {sortItem.name}
                    </div>
                  )
                }}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  )
}

export default PropertiesSortSelect
